export const showError = (args: any) => {
  alert(JSON.stringify(args))
}
